import { render, staticRenderFns } from "./ShareholderListProvider.vue?vue&type=template&id=bf668a76&scoped=true&"
import script from "./ShareholderListProvider.vue?vue&type=script&lang=ts&"
export * from "./ShareholderListProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf668a76",
  null
  
)

export default component.exports